<template>
  <div class="index">
    <div class="index_inner">
      <div class="index_banner">
        <img alt="" class="img" src="../assets/image/banner.jpg"/>
      </div>
    </div>
    <div class="index_body">
      <div style="width: 90%; margin: 0 auto">
        <div class="index_body_img">
          <img src="../assets/image/finish.png"/>
        </div>
      </div>

      <div class="input-container">
        <div class="input-item">
          <div class="input-item-inner large" style="flex-direction: column">
            <div class="input-item-sub">
              <span class="input-item-label" style="color: #666">出行人数</span>
              <div class="input-item-info">
                <p class="info">{{ staff.tickets.adult + 1 }}人</p>
              </div>
            </div>

            <div class="input-item-sub">
              <span class="input-item-label" style="color: #666">联系方式</span>
              <div class="input-item-info">
                <p class="info">{{ staff.tel }}</p>
              </div>
            </div>


            <div class="input-item-sub">
              <span class="input-item-label" style="color: #666">活动体验券寄送地址</span>
              <div class="input-item-info">
                <p class="info">
                  {{ staff.recCity.join("") }}<br>
                  {{ staff.recAddr }}
                </p>
                <p class="info">{{ staff.recName }}</p>
                <p class="info">{{ staff.recTel }}</p>
              </div>
            </div>

            <div class="input-item-sub">
              <span class="input-item-label" style="color: #666"
              >票券邮寄单号</span
              >
              <div class="input-item-info">
                <p v-if="staff.tracking_no" class="info">
                  {{ staff.tracking_no }}
                </p>
                <p v-else class="info" style="font-style: italic">待发出</p>
              </div>
            </div>
          </div>
        </div>

        <p class="tracking_tips">
          供应商将在7月19日报名截止后2周时间内，统一安排票券邮寄，您可通过此报名系统或邮件提醒了解票券发放进度，如有问题请联系活动管理员leqiliao@imprforest.com。
        </p>
      </div>
    </div>

    <div v-if="isShowDesc" class="style_info_box" @click="closeDesc">
      <div class="span_box">
        <span class="loading">Loading…</span>
      </div>
      <div class="back_box">
        <span class="span_back"><</span><span>返回上一页</span>
      </div>
      <div class="img_box style_img_box">
        <img :src="descImgUrl"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "score",
  data() {
    return {
      isShowDesc: false,
      descImgUrl: "",
      descImgList: {}
    };
  },
  mounted() {
    if (this.staff.recName.length < 1) {
      this.$router.replace({path: "/"});
    }
    // console.log(this.getScore());
    // console.log(this.getResult());
  },
  computed: {
    ...mapState({
      staff: (state) => state.staff
    }),
    childData() {
      if (this.staff.tickets.child <= 0) {
        return "";
      }

      let countData = this.staff.tickets.child_height.reduce((acc, cur) => {
        acc[cur] = (acc[cur] || 0) + 1;
        return acc;
      }, {});

      let childData = [];
      Object.entries(countData).forEach(([key, value]) => {
        childData.push(`${key} ${value}人`);
      });

      return childData;
    }
  },
  methods: {
    showDescImg() {
      this.isShowDesc = true;
    },
    closeDesc() {
      this.isShowDesc = false;
      this.descImgUrl = "";
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../assets/mixins.styl'

.tracking_tips
  font-size 28px
  line-height 1.6em


.index
  width 750px
  min-height 100vh
  position relative
  margin 0 auto
  background #ecf9ff

  .index_inner
    width 750px
    height 100%

    .index_banner
      width 100%
      line-height 0

      .img
        width 100%;

  //box-shadow 10px 10px 15px rgba(0, 0, 0, 0.2);

  .index_body
    width 750px
    //height 80vh
    //position absolute
    //top 300px
    display flex
    flex-direction column
    align-items center

    .index_body_img
      margin-top 20px
      text-align center

      img
        width 90%

    .color-notice
      color #f24b52

    .input-container
      width 90%

      .link
        font-size 28px
        color #039fff

      .input-calendar
        width: calc(750px * 0.8);
        z-index: 999;
        position: absolute;
        right: 0;
        top: 50px;
        display: flex;
        flex-direction: row;
        justify-content: center

      .input-item
        margin-bottom 20px

      .input-box
        width 100%
        border none
        font-size 32px
        //border-bottom solid 1px #a1a4ad
        margin 10px

        &.underline
          border-bottom solid 1px #a1a4ad

        &:focus
          outline none

      .input-validate
        position absolute
        top 20px
        right 20px
        line-height 24px

        &.success
          color #009966

        &.error
          color #f24b52

      .city_wrapper
        width 100%
        display flex
        flex-direction column
        margin-bottom 10px;

        .city_wrapper_title
          display block
          font-size 32px
          padding-bottom 20px

      &.notice
        p
          margin 0
          font-size 24px
          color #f24b52

    .input-title
      font-size 26px
      margin-left 1em
      padding-top 20px
      padding-bottom 5px

      &:first-child
        padding-top 0

    .input-item
      width 100%
      background #ffffff
      border-radius 15px
      display flex
      flex-direction row
      flex-wrap wrap
      justify-content space-between
      fontFamily()
      font-size 28px
      padding 10px 10px
      box-sizing border-box

      .input-item-label
        color #666666

      .input-item-title
        color #000000
        font-weight bold
        font-size 32px

        .title-tips
          color #666666
          font-size 24px
          padding-left 10px

        p.title-tips
          margin 0

        p.tips
          font-size 24px
          margin 5px 0 0 0

      .input-item-info
        flex 1
        display flex
        flex-direction column
        justify-content right

        p
          margin 0
          text-align right
          font-size 28px
          line-height 42px

      .input-item-inner
        flex 1
        display flex
        justify-content right

        input
          min-width 16em
          height 100%
          text-align right
          border none
          font-weight bold

          &::placeholder
            font-size 24px
            color #000

        input[type="checkbox"]
          width 2em
          min-width auto

        //accent-color white


        &.number
          align-items center
          color #f24b52
          font-weight bold
          font-size 1.2em

      .input-item-sub
        width 100%
        display flex
        flex-direction row
        margin-top 20px

        &.list
          flex-direction column

        .subitem-title
          flex 1

          p
            margin 0

          .title
            font-size 28px

            .title-tips
              color #f24b52
              font-size 24px

          .tips
            color #666666
            font-size 24px
            padding-left 10px

        .input-select
          display flex
          flex-direction row
          justify-content space-between
          margin-bottom 10px

          &:last-child
            margin-bottom 0

          .label
            color #ff6600
            line-height 50px;
            vertical-align middle

          .options
            span
              display inline-block
              margin-right 40px
              padding 5px 30px;
              border-radius 30px
              background #e0e0e0
              border solid 1px #e0e0e0
              line-height 40px;
              vertical-align middle

              &:last-child
                margin-right 0

              &.selected
                border solid 1px #039fff
                background white

            &.static
              span
                color #ffffff
                background #0070c0
                border #0070c0
                margin-right 10px

                &:last-child
                  margin-right 0

      .input-num-btn
        width 150px
        display inline-flex
        align-items center
        justify-content right

        .label-num
          width 1em
          display inline-block
          margin 0 10px
          font-size 36px
          font-weight bold
          text-align center
          color #333333

        .btn-add,
        .btn-minus
          width 36px
          height 36px
          line-height 32px
          font-size 36px
          font-weight bold
          display inline-block
          border solid 1px #666666
          border-radius 50%
          color #666666
          text-align center
          cursor pointer

          &.disabled
            background #dddddd

    .body-actions
      width 100%
      display flex
      margin-top 20px
      margin-bottom 50px
      flex-direction row
      justify-content space-around

      button
        font-size 36px !important

      .btn-prev
        buttonSet()
        width 300px
        background #a6b4a8

        &:disabled
          background $deepGray

      .btn-next
        buttonSet()
        width 300px

    .input-container
      .select-place
        width 100%;
        display flex
        flex-direction column

        .place
          width 100%
          margin-bottom 30px;
          position relative

          .place-img
            width 100%

            img
              width inherit

          .select-btn
            position absolute
            width 100%
            top 160px
            display flex
            flex-direction row
            justify-content center

            .button
              buttonSet()
              scale 60%
              font-size 68px

          .place-desc
            width 100%;
            padding-top 5px
            text-align center

            span
              color #039fff
              font-size 28px

    .ticket-tips
      width 100%
      color #f24b52
      font-style italic
      margin 10px 0 10px 0
      border-bottom dashed 5px #e1e2e6

.style_info_box
  position absolute
  top 0
  right 0
  bottom 0
  left 0
  width 100%
  height 100%
  background-color rgba(0, 0, 0, 0.6)

  .span_box
    position relative
    //background-color red
    width 100%
    height 100vh
    color white
    display flex
    align-items center
    justify-content center
    font-size 50px

  .back_box
    position fixed
    top 0
    z-index 99
    width 100%
    height 100px
    background-color white

    span
      display inline-block
      font-size 48px
      font-family()
      font-weight bold
      color #000
      line-height 100px
      padding 0 30px 0

    .span_back
      transform scale(1, 2)

  .img_box
    position absolute
    top 80px
    width 100vw
    //background-color  yellow

    img
      z-index 99
      width 100%

::v-deep .vc-container {
  width 80%;
  --rounded: 15px !important
  --rounded-lg: 15px !important
}

::v-deep area-cascader-wrap {
  display inline-block
}

::v-deep .area-select {
  position: relative;
  display: inline-block;
  vertical-align: top;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 50px;
  width: 100%;
  cursor: pointer;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e1e2e6;
  margin 0
}

::v-deep .area-select-wrap {
  display inline-flex
}

::v-deep .area-select-wrap .area-select {
  margin 0 0 20px
}

::v-deep .area-select .area-selected-trigger {
  position: relative;
  display: block;
  font-size: 24px;
  cursor: pointer;
  margin: 0;
  line-height 50px;
  overflow: hidden;
  white-space: nowrap;
  //text-overflow: ellipsis;
  height: 100%;
  padding: 0 0 0 44px
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 10px;
}

::v-deep .area-selectable-list-wrap {
  max-height 500px
}

::v-deep .area-select .area-select-icon {
  border 10px solid transparent
  border-top-color: #a1a4ad;
  position: absolute;
  top: 50%;
  //margin-top: -0.026667rem;
  right: 40px;
}

::v-deep .area-selectable-list {
  font-size: 40px !important;
}

::v-deep .area-selectable-list .area-select-option {
  padding 0 0 0 44px
  font-size 30px
  height 68px
  line-height 68px
}

::v-deep .area-selectable-list .area-select-option.selected {
  background-color: #e4e8f1;
  color $theme
  font-weight: 700
}

::v-deep .cascader-menu-list .cascader-menu-option.selected {
  background-color: #e4e8f1;
  color $theme
  font-weight: 700
}

//::v-deep .cascader-menu-list .cascader-menu-option {
//  position: relative;
//  white-space: nowrap;
//  overflow: hidden;
//  text-overflow: ellipsis;
//  cursor: pointer;
//  padding: 0 15px 0 20px;
//  height: 50px;
//  line-height: 50px
//}

::v-deep .cascader-menu-list {
  position: relative;
  margin: 0;
  font-size: 26px;
  color: #565656;
  padding: 6px 0;
  list-style: none;
  display: inline-block;
  height: 430px;
  overflow-x: hidden;
  overflow-y: auto;
  min-width: 150px;
  vertical-align: top;
  background-color: #fff;
  border-right: 1px solid #e4e7ed
}
</style>
